(function () {
  'use strict';

  var KEY = 'mdc-theme';
  var root = document.documentElement;

  var canStore = (function () {
    try {
      localStorage.setItem(KEY + ':probe', '1');
      localStorage.removeItem(KEY + ':probe');
      return true;
    } catch (err) {
      if (typeof console !== 'undefined' && console.warn) {
        console.warn('MDC theme: preference will not persist -', err && err.message);
      }
      return false;
    }
  })();

  function stored() {
    return canStore ? localStorage.getItem(KEY) : null;
  }

  function remember(v) {
    if (canStore) localStorage.setItem(KEY, v);
  }

  var DARK_CANVAS = '16 19 23';
  var CANVAS_RGB = [16, 19, 23];
  var DARK_INK = '232 234 237';

  function parseRGB(v) {
    var m = String(v).trim().match(/^(\d+)\s+(\d+)\s+(\d+)$/);
    return m ? [+m[1], +m[2], +m[3]] : null;
  }
  function relLum(rgb) {
    var c = rgb.map(function (v) {
      v /= 255; return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
    });
    return 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2];
  }
  function contrast(a, b) {
    var l1 = relLum(a), l2 = relLum(b);
    var hi = Math.max(l1, l2), lo = Math.min(l1, l2);
    return (hi + 0.05) / (lo + 0.05);
  }
  function liftFor(rgb, bg, need) {
    var out = rgb.slice();
    for (var i = 0; i < 100 && contrast(out, bg) < need; i++) {
      out = out.map(function (v) { return Math.min(255, Math.round(v + (255 - v) * 0.06)); });
    }
    return out;
  }

  function describe(rgb) {
    var r = rgb[0] / 255, g = rgb[1] / 255, b = rgb[2] / 255;
    var max = Math.max(r, g, b), min = Math.min(r, g, b);
    var l = (max + min) / 2;
    var sat = max === min ? 0 : (max - min) / (1 - Math.abs(2 * l - 1));
    return { sat: sat, light: l };
  }

  function remapSections(theme) {
    var secs = document.querySelectorAll('[id^="shopify-section-"]');
    for (var i = 0; i < secs.length; i++) {
      var el = secs[i];
      if (theme !== 'dark') {
        el.style.removeProperty('--color-background');
        el.style.removeProperty('--color-background-2');
        el.style.removeProperty('--color-foreground');
        continue;
      }
      var cs = window.getComputedStyle(el);
      ['--color-background', '--color-background-2'].forEach(function (prop) {
        var rgb = parseRGB(cs.getPropertyValue(prop));
        if (!rgb) return;
        var d = describe(rgb);
        if (d.sat < 0.18 && d.light > 0.6) el.style.setProperty(prop, DARK_CANVAS);
      });
      var fg = parseRGB(cs.getPropertyValue('--color-foreground'));
      if (fg) {
        var df = describe(fg);
        if (df.sat < 0.18 && df.light < 0.4) {
          el.style.setProperty('--color-foreground', DARK_INK);
        } else if (contrast(fg, CANVAS_RGB) < 4.5) {
          el.style.setProperty('--color-foreground', liftFor(fg, CANVAS_RGB, 4.5).join(' '));
        }
      }
    }
  }

  function apply(theme) {
    root.setAttribute('data-theme', theme);
    remapSections(theme);
    var meta = document.querySelector('meta[name="theme-color"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'theme-color';
      document.head.appendChild(meta);
    }
    meta.setAttribute('content', theme === 'dark' ? '#101317' : '#ffffff');

    document.querySelectorAll('.mdc-theme-toggle').forEach(function (btn) {
      btn.setAttribute('aria-checked', theme === 'dark' ? 'true' : 'false');
      btn.setAttribute('aria-label', theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode');
      btn.setAttribute('title', btn.getAttribute('aria-label'));
    });
  }

  function lockDarkReader() {
    if (document.querySelector('meta[name="darkreader-lock"]')) return;
    var m = document.createElement('meta');
    m.name = 'darkreader-lock';
    document.head.appendChild(m);
  }

  var current = stored() === 'light' ? 'light' : 'dark';
  lockDarkReader();
  apply(current);

  function toggle() {
    current = current === 'dark' ? 'light' : 'dark';
    remember(current);
    apply(current);
  }

  var SUN = '<svg class="mdc-icon-sun" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4"/></svg>';
  var MOON = '<svg class="mdc-icon-moon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z"/></svg>';

  function build() {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'mdc-theme-toggle';
    btn.setAttribute('role', 'switch');
    btn.innerHTML =
      '<span class="mdc-theme-toggle__track">' +
        '<span class="mdc-theme-toggle__knob">' + SUN + MOON + '</span>' +
      '</span>';
    btn.addEventListener('click', toggle);
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () { btn.classList.add('is-ready'); });
    });
    return btn;
  }

  function mountDrawer() {
    var list = document.querySelector('ul.drawer__menu');
    if (!list || list.querySelector('.mdc-theme-toggle')) return false;
    var li = document.createElement('li');
    li.className = 'drawer__menu-group mdc-theme-drawer-row';
    var label = document.createElement('span');
    label.className = 'mdc-theme-drawer-label';
    label.textContent = 'Dark mode';
    li.appendChild(label);
    li.appendChild(build());
    list.appendChild(li);
    return true;
  }

  function mount() {
    var hosts = document.querySelectorAll('.header__buttons');
    var added = false;
    for (var i = 0; i < hosts.length; i++) {
      var isActions = hosts[i].querySelector('.cart-drawer-button, a[href$="/cart"]')
        || (hosts[i].parentElement && hosts[i].parentElement.classList.contains('header__icons--end'));
      if (!isActions) continue;
      if (hosts[i].querySelector('.mdc-theme-toggle')) continue;
      hosts[i].insertBefore(build(), hosts[i].firstChild);
      added = true;
    }
    if (mountDrawer()) added = true;
    if (added) apply(current);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount);
  } else {
    mount();
  }
  new window.MutationObserver(function () { mount(); })
    .observe(document.documentElement, { childList: true, subtree: true });
})();
